'use client';

import React from 'react';
import { useStore } from '@/store/store';
import { useGlobalContext } from '@/store/contexts/global-context';
import { POPUPS } from '@/app/components/popup/constants';
import { GameInfoModalWeb } from './layouts/game-info-modal-web';
import { GameInfoModalAndroid } from './layouts/game-info-modal-android';

import './styles/@theme';

export const GameInfoModal: React.FC = () => {
    const { queue } = useStore((state) => state.popup);
    const { isMobile } = useGlobalContext();

    const hasGameInfo = queue.some((item) => item.type === POPUPS.GAME_INFO);

    if (!hasGameInfo) {
        return null;
    }

    if (isMobile) {
        return <GameInfoModalAndroid />;
    }

    return <GameInfoModalWeb />;
};
